export default {
	getById(id, cb) {
		this.http.get(`/game/getById/${id}`, {}).then((r) => cb && cb(r))
	},
	status(id, to, cb, ecb) {
		this.http
			.get(`/game/status/${id}/${to}`)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	search(params, cb) {
		this.http.get('/game/search/', { params }).then((r) => cb && cb(r))
	},
	update(e, cb, ecb, config = {}) {
		this.http
			.post('/game/update', e, config)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	getAwards(id, cb) {
		this.http.get(`/game/awardList/${id}`, {}).then((r) => cb && cb(r))
	}
}
